import React, { useState } from 'react';

const OutageBanner = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  const isOutage = process.env.REACT_APP_TECHNICAL_OUTAGE === 'true';
  const message = process.env.REACT_APP_TECHNICAL_OUTAGE_MESSAGE ||
    'We are currently experiencing technical difficulties. Some features may be temporarily unavailable.';

  if (!isOutage || isDismissed) return null;

  return (
    <div className="fixed top-0 left-0 w-full bg-amber-500 text-black z-[9999] shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          <svg 
            aria-hidden="true"
            className="w-5 h-5 flex-shrink-0" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path 
              fillRule="evenodd" 
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" 
              clipRule="evenodd" 
            />
          </svg>
          <p className="text-sm font-medium">{message}</p>
        </div>
        <button
          type="button"
          onClick={() => setIsDismissed(true)}
          className="flex-shrink-0 p-1 rounded-full hover:bg-amber-600 transition-colors"
          aria-label="Dismiss banner"
        >
          <svg 
            aria-hidden="true"
            className="w-5 h-5" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M6 18L18 6M6 6l12 12" 
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default OutageBanner;
